export default __webpack_public_path__ + "7f01b07148f205f6e8258e92bbf652d9.png";